module.exports = __webpack_public_path__ + "media/application/images/svgs/external-link-7a79ec1b9aecbea3dcbaa1ea06d9170d.svg";